import moment from 'moment'

const state = {
  now: moment(),
  timeSincePdfWarmed: moment().subtract(1, 'day'),
}

const getters = {
  currentTime: (state) => {
    return state.now
  },
  shouldPdfBeWarmed: (state) => {
    return moment.duration(moment().diff(state.timeSincePdfWarmed)).as('hours') > 12
  },
}

const actions = {
  startNowTimer({ commit }) {
    setInterval(() => {
      commit('updateTime')
    }, 1000)
  },
  updateNow({ commit }) {
    commit('updateTime')
  },
  updatePdfWarmed({ commit }) {
    commit('updatePdfWarmed')
  },
}

const mutations = {
  updateTime(state) {
    state.now = moment()
  },
  updatePdfWarmed(state) {
    state.timeSincePdfWarmed = moment()
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
